<template>
  <div>
    <div class="top-bar">
      <p>Godfrey Beverage Solutions</p>
    </div>
    <header class="intro">
      <img class="header-img" src="../assets/bens-field-skinny.jpg" alt="Apples" />
      <div class="intro-text-wrapper">
        <h1 class="intro-acronymn">GBS</h1>
        <h1 class="intro-h1">
          Let's Create, Refine, or Expand Your Craft Beverage Business Today
        </h1>
      </div>
    </header>
    <div class="section-one">
      <div class="intro-greeting-text">
        <h1 class="section-one-h1">Hey, I'm Tim!</h1>
        <h2 class="intro-h2">Founder of Godfrey Beverage Solutions</h2>
        <h3 class="intro-h3">
          With 10+ Years of Professional Experience in the Cider and Wine
          Industry from the barrel room to the board room and everywhere in
          between, I'm here to help your company thrive.
        </h3>
      </div>
      <div class="intro-img-wrapper">
        <img id="section-one-img" src="../assets/tim-overalls.jpg" alt="Tim pic" />
      </div>
    </div>
    <div class="section-two-wrapper">
      <div class="section-two">
        <h1 class="section-titles" id="history">Who We Are</h1>
        <h2>
          Since 2012, Tim has been producing cider and wine professionally all
          across the United States.
        </h2>
        <div class="history-text-box">
          <div class="history-text-item one">
            <img class="section-two-img" src="../assets/flower-blossum.jpg" alt="Tim pic" />
          </div>
          <div class="history-text-item two">
            <img class="section-two-img" src="../assets/time-looking-left.jpg" alt="Tim pic" />
          </div>
          <div class="history-text-item three bottom-row">
            <h5>
              <!--
              His interest in fermentation originated during his time as an
              undergrad studying Cellular and Molecular Biology, after which he
              became a graduate of the UC Davis Winemaking Certificate Program.
              His technical expertise surrounds everything fermentation and
              production, which is rounded out with over 10 years of experience
              in orchard scouting, product development, facility planning and
              build out, quality control, and sensory evaluation.-->
              Tim's interest in the fermentation process originated during his time as an
              undergrad studying Cellular and Molecular Biology. The knowledge and experience
              gained through his studies inspired him to pursue and ultimately complete the
              UC Davis Winemaking Certificate Program. Tim's technical expertise includes
              fermentation, production processes, and everything in between. 
              With over 10 years of experience in orchard scouting, product development,
              facility planning and build out, quality control, and sensory evaluation, 
              Tim will have a solution for your business.

            </h5>
          </div>
          <div class="history-text-item four bottom-row">
            <h5>
              <!--
              Tim has spent years at the executive level of Production
              Management and is passionate about leadership mentoring and team
              dynamics while growing a profitable beverage business. He has been
              involved with the American Cider Association since 2019 developing
              the Certified Cider Professional and Pommelier training programs
              and exams, working to shape cider education and development as it
              is taken to the masses.-->
              Tim has spent years at the executive level of Production Management.
              He is passionate about leadership mentoring and efficient team
              dynamics to drive success and ultimately grow a profitable beverage business.
              He has been involved with the American Cider Association since 2019, helping create
              the Certified Cider Professional and Pommelier training programs,
              shaping cider education and development across the country. His background in training and education, coupled
              with his scientific approach to fermentation has proven invaluable to beverage companies like yours. 
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="services-wrapper" :class="expanded ? 'services-wrapper-expanded' : 'services-wrapper'">
      <div class="services-wrapper-intro">
        <h1 class="section-titles" id="services">Services</h1>
        <h3>What can Godfrey Beverage Solutions do for you?</h3>
      </div>
      <div class="services-wrapper-offers">
        <div class="offer">
          <h3>Business Strategy & Operations</h3>
          <ul>
            <li>Operational Costing and Budgeting</li>
            <li>Licensing, Operations Reporting, and Product Compliance</li>
            <li>Facility Planning and Site Review</li>
            <li>Leadership Coaching and Mentoring</li>
            <li>Team Development</li>
          </ul>
        </div>
        <div class="offer">
          <h3>Production & Fermentation</h3>
          <ul>
            <li>Equipment Sourcing and Budgeting</li>
            <li>Product Development and Analysis from Bin to Bottle</li>
            <li>Fermentation Coaching and Troubleshooting</li>
            <li>SOP Review and Development</li>
            <li>Product Stability and Packaging Programs</li>
          </ul>
        </div>
        <div class="offer">
          <h3>Quality & Sensory Analysis</h3>
          <ul>
            <li>Laboratory Development and Equipment Sourcing</li>
            <li>Sanitation and Cleaning Audit and Development</li>
            <li>Sensory Analysis Program Development</li>
            <li>Cider and Wine Education and Training</li>
            <li>Safety Program Review and Development</li>
          </ul>
        </div>
      </div>
    </div>
    <footer>
      <div v-if="expanded" class="expandedFooter">
        <img src="../assets/down-arrow.png" @click="shrinkFooter" />
        <ContactForm></ContactForm>
      </div>
      <div v-else class="shrunkFooter">
        <img src="../assets/up-arrow.png" @click="expandFooter" />
        <p class="footer-text">Click Here To Contact Us Today!</p>
      </div>
    </footer>
  </div>
</template>
<script>
import ContactForm from "./ContactForm";
export default {
  name: "Homepage",
  data() {
    return {
      expanded: false,
    };
  },
  props: {
    msg: String,
  },
  methods: {
    expandFooter() {
      this.expanded = true;
    },
    shrinkFooter() {
      this.expanded = false;
    },
  },
  components: {
    ContactForm,
  },
};
/* TO-DO: 
    1. Fix Mobile
    2. Add Form validation
    3. Make Sure Pictures and Text are good
    4. Change Emails
    5. Add GIT to workflow in AWS?

*/
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Courgette&family=Quicksand&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Mulish:wght@300&display=swap");

.top-bar {
  background-color: white;
  text-align: center;
  font-size: 12px;
  padding: 20px;
  letter-spacing: 0.15em;
  display: block;
}

.top-bar p {
  color: black;
  margin: 0;
}

.intro {
  position: relative;
  overflow: hidden;
  max-height: 40rem;
}

.header-img {
  opacity: 0.6;
}

.intro-text-wrapper {
  position: absolute;
  left: 10%;
  top: 25%;
  width: 40%;
}

.intro-img-wrapper {
  width: 50%;
  height: 100%;
}

.intro img {
  position: relative;
  width: 100%;
  object-fit: cover;
}

.intro-greeting-img-wrapper {
  height: 25rem;
  border: 1px solid black;
  margin: auto 3rem;
  display: flex;
}

.intro-acronymn {
  color: black;
  font-size: 10rem;
  font-family: "Archivo Black", sans-serif;
  border-bottom: dimgray;
  border-style: none none solid none;
}

.intro-h1 {
  color: black;
  margin: 30px 0;
}

.section-one-h1 {
  color: black;
  margin: 30px 0;
  font-size: 3.5rem;
  font-weight: bolder;
}

.history-text-item h5 {
  line-height: 1.5;
}

.intro-h2 {
  color: black;
  margin: 30px 0;
}

.intro-h3 {
  font-size: 1.2rem;
  margin: 15px 0;
}

.section-one {
  display: flex;
  margin: 0rem auto;
  background-color: whitesmoke;
  align-items: center;
  justify-content: center;
  padding: 5rem 0;
}

.section-two-wrapper {
  width: 100%;
  height: 100%;
  background-color: #9cadbe54;
}

.section-two {
  width: 90%;
  margin: 0 auto;
  padding: 5rem 0;
}

.section-two h2 {
  margin: 3rem;
  font-size: larger;
  text-align: center;

}

.section-titles {
  overflow: hidden;
  text-align: center;
}

.section-titles:before,
.section-titles:after {
  background-color: #000;
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 50%;
}

.section-titles:before {
  right: 0.5em;
  margin-left: -50%;
}

.section-titles:after {
  left: 0.5em;
  margin-right: -50%;
}


.section-two h5 {
  font-size: 1.1rem;
}

.history-text-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.history-text-item {
  flex: 1 1 50%;
  padding: 2rem;
}

.bottom-row {
  padding: 2rem 8rem;
}

.section-two-img {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.intro-greeting-text {
  width: 35%;
  margin: 50px auto;
}

body {
  font-family: "Josefin Sans", sans-serif !important;
  padding-top: 50px;
  background-color: #dfdfdf !important;
}

#section-one-img {
  width: 45%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.services-wrapper {
  width: 80%;
  margin: auto;
  text-align: center;
  padding: 5rem 0 15rem 0;
}

.services-wrapper-expanded {
  padding-bottom: 400px;
}

.services-wrapper-intro {
  margin: 5rem auto;
}

.services-wrapper-intro h1 {
  margin: 2rem auto;
}

.services-wrapper-offers {
  display: inline-flex;
  margin: 10px 10px;
  text-align: left;
}

.offer {
  margin: 0 10px 0 10px;
  text-align: center;
  padding-bottom: 2rem;
}

.offer ul {
  text-align: left;
  line-height: 2.5;
}

.offer li {
  margin: 5px 0;
}

.offer h3 {
  font-weight: bold;
  margin-bottom: 20px;
}

.expandedFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: gray;
  text-align: center;
  background-color: #ced4da;
  height: 650px;
  transition: height 500ms ease-in;
}

.shrunkFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: gray;
  text-align: center;
  background-color: #9cadbed9;
  height: 100px;
  transition: height 500ms ease-in;
  opacity: .7;
}

footer img {
  width: 50px;
  margin: 5px;
}

.footer-text {
  color: black;
  font-weight: bold;
}

@import url(https://fonts.googleapis.com/css?family=Roboto:400,300,600,400italic);

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  -o-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  /*list-style-type: none !important;*/
}

/* media queries */
@media only screen and (max-width: 500px) {
  .intro-text-wrapper {
    width: 50%;
  }

  .intro-h3 {
    font-size: 1rem;
    margin: 15px 0;
  }

  #section-one-img {
    width: 75%;
  }

  .bottom-row {
    padding: 2rem 35px;
  }

  .offer ul {
    padding: 0;
  }

  .section-titles {
    font-weight: bolder;
  }

  .offer li {
    line-height: 2;
    list-style-type: disc;
    margin: 8px 10px;
    text-align: left;
  }

  .expandedFooter{
    height: 80%;
}

}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 800px) {
  .intro img {
    height: 35rem;
  }

  .section-one {
    overflow-x: hidden;
  }

  .section-one-h1[data-v-54d3a52e] {
    color: black;
    margin: 30px 0;
    font-size: 2.5rem;
    font-weight: bolder;
  }

}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 1199px) {

  /* * {
    background-color: green;
  } */
  .offer ul {
    text-align: center;
    list-style-type: none;
  }

  .intro-text-wrapper {
    top: 15%;
  }

  .intro-acronymn {
    font-size: 8rem;
  }

  .intro-h1 {
    font-size: 25px;
  }

  .section-one {
    display: block;
    text-align: center;
  }

  .intro-greeting-text {
    width: 90%;
    margin: 50px auto;
  }

  .intro-img-wrapper {
    width: 100%;
  }

  .history-text-box {
    display: block;
  }

  .services-wrapper-offers {
    display: block;
  }

  .offer h3 {
    margin-bottom: 30px;
  }

}
</style>